import { observer } from 'mobx-react-lite'
import { ContentError } from '@/components/ContentError'
import { type EditBusinessProfileDialogViewModel } from '@/features/jobs/info-gathering/business-info/components/EditBusinessProfileDialog/EditBusinessProfileDialogViewModel'
import { type BusinessInfoViewModel } from '@/features/jobs/info-gathering/business-info/BusinessInfoViewModel'
import { BusinessInfo } from '@/features/jobs/info-gathering/business-info/components/BusinessInfo'

export interface BusinessInfoContainerProps {
  vm: BusinessInfoViewModel
  editVm: EditBusinessProfileDialogViewModel | null
}

export const BusinessInfoContainer = observer(function BusinessInfoContainer({
  vm,
  editVm,
}: BusinessInfoContainerProps) {
  const profile = vm.profile

  if (!vm.item.completed && !editVm) {
    return null
  }

  const renderProfile = (isLoading: boolean) => (
    <BusinessInfo
      hasProfile={vm.item.completed}
      isLoading={isLoading}
      isEditable={!!editVm?.canShow}
      onEdit={editVm?.show}
      businessName={profile?.businessInfo.businessName}
      dateOfIncorporation={vm.dateOfIncorporation}
      employerIdentificationNumber={
        profile?.businessInfo.employerIdentificationNumber
      }
      maskedEmployerIdentificationNumber={vm.maskedEmployerIdentificationNumber}
      address={profile?.contactInfo.physicalAddress}
      emptyStateActionTestId="business-profile-empty-state-action"
      editButtonTestId="update-business-information-button"
    />
  )

  return vm.fetch.match({
    pending: () => renderProfile(true),
    rejected: (err) => <ContentError error={err} />,
    resolved: () => renderProfile(false),
  })
})
